module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-shadow-16.3e2f4e38.png";